import {
  ENDPOINT_ITEMS,
  ENDPOINT_ROOT,
  ENDPOINT_WISHLISTS,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const patchWishlistItems = ({ wishlist, item }) => {
  const params = {
    is_selected: item.isSelected,
    quantity: item.quantity,
    comment: item.comment,
  };

  return axiosAuth
    .patch(
      `${ENDPOINT_ROOT}/${ENDPOINT_WISHLISTS}/${wishlist.id}/${ENDPOINT_ITEMS}/${item.id}`,
      { ...params },
    )
    .then((res) => res.data);
};

export default patchWishlistItems;
